<template>
  <div class="view-buylicense">
    <subscription-ordering-form
      v-model:planId="planId"
      v-model:seats="seats"
      :fixed-payment-method="paymentMethod"
      :same-page="true"
      @done="onOrderDone($event)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import SubscriptionOrderingForm from "./SubscriptionOrderingForm.vue";

import type { Subscription } from "@/api/subscriptions.store";

const router = useRouter();
const route = useRoute();

const planId = computed({
  get() {
    return route.query.planId as string;
  },
  set(value: string) {
    router.push({
      query: {
        ...route.query,
        planId: value
      }
    });
  }
});

const seats = computed({
  get() {
    if (!route.query.seats) {
      return 1;
    }
    return parseInt(route.query.seats as string);
  },
  set(value: number) {
    router.push({
      query: {
        ...route.query,
        seats: value.toString()
      }
    });
  }
});

const paymentMethod = computed((): "invoice" | "quote" | "stripe" | undefined => {
  const validMethods = ["invoice", "quote", "stripe"];
  const method = route.query.paymentMethod as string;
  if (validMethods.includes(method)) {
    return method as "invoice" | "quote" | "stripe";
  }
  return undefined;
});

function onOrderDone(subscription: Subscription | null) {
  if (subscription && subscription.organization) {
    router.push({ name: "settings-organization", params: { organizationSlug: subscription.organization.slug } });
  } else {
    router.push({ name: "settings-subscriptions" });
  }
}
</script>

<style lang="scss">
.view-buylicense {
  height: 100%;
  overflow: auto;
  scrollbar-gutter: stable;

  background-image: linear-gradient(180deg, var(--color-primary-light) 0rem, var(--color-background) 30rem);
}
</style>
